import React from "react";
import classes from "./InputText.module.css";

const InputText = ({ label, name, value, setValue, border, readOnly, onBlur }) => {

    return <div className={classes.InputText}>
        <div className={classes.Label}>{label}</div>
        <input
            className={`${classes.Input} ${border && classes.Border}`}
            type={"text"}
            value={value}
            name={name}
            onChange={(e) => setValue(name, e.target.value)}
            onBlur={() => onBlur && onBlur()}
            readOnly={readOnly}>
        </input>
    </div>
}

export default InputText;
